/*
 * @Author: hai.zhang
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Date: 2019-09-20 10:02:00
 * @LastEditTime: 2022-10-13 16:00:48
 */
// import VueRouter from 'vue-router'
// import LayoutMain from 'pages/index/src/routes/layout-main'
// import LayoutMainFixed from 'pages/index/src/routes/layout-main-fixed'
// import LayoutFixedContainer from 'pages/index/src/routes/layout-fixed-container'
// import layoutFluidContainer from 'pages/index/src/routes/layout-fluid-container'
import LayoutWrap from 'pages/index/src/routes/layout-wrap'
import mall from './mall'
import setting from './setting'
import order from './order'
import requisition from './requisition'
import cart from './cart'
import favorite from './favorite'
import evaluate from './evaluate'
import error from './error'
import pundchoutAvoidLogin from './pundchout-avoid-login'
import scene from './scene'
import processrouter from './process'
import frequent from './frequent'
import member from './member'
import requireList from './require-list'
import pr from './pr'
import portal from './portal'
import paas from './paas'
import help from './help'

const fixedPage = [
  ...pr.fixed,
  ...order.fixed,
  ...requisition.fixed,
  ...requireList.fixed,
  ...evaluate.fixed,
  ...paas.fixed,
  ...help.fixed,
  ...processrouter.fixed
]

const fluidPage = [
  ...setting.fluid,
  ...order.fluid,
  ...favorite.fluid,
  ...pundchoutAvoidLogin.fluid,
  ...evaluate.fluid,
  ...requisition.fluid,
  ...frequent.fluid,
  ...requireList.fluid,
  ...mall.field,
  ...pr.field,
  ...portal.field,
  ...paas.fluid
]

const mainPage = [
  ...mall.main,
  ...cart.main,
  ...scene.main,
  ...pundchoutAvoidLogin.main
]

const noTabFramePage = [
  ...mall.main,
  ...cart.main,
  ...scene.main,
  ...pundchoutAvoidLogin.main,
  ...help.fixed,
  ...processrouter.fixed
]

// 添加路由layout属性
// noTabFrame 属性，建议在路由表中写，这里只是修改存量页面
if (fixedPage?.length) {
  fixedPage.forEach(pageItem => {
    if (pageItem.meta && !pageItem.meta?.layout) pageItem.meta.layout = 'fixed'
  })
}
if (fluidPage?.length) {
  fluidPage.forEach(pageItem => {
    if (pageItem.meta && !pageItem.meta?.layout) pageItem.meta.layout = 'fluid'
  })
}
if (mainPage?.length) {
  mainPage.forEach(pageItem => {
    if (pageItem.meta && !pageItem.meta?.layout) pageItem.meta.layout = 'main'
  })
}
if (noTabFramePage?.length) {
  noTabFramePage.forEach(pageItem => {
    if (pageItem.meta && !pageItem.meta?.noTabFrame) pageItem.meta.noTabFrame = true // 固定不走页签
  })
}

const routes = [
  // 商城前台页面布局（没有页签框架）
  // {
  //   path: '/',
  //   component: LayoutMain,
  //   children: [
  //     ...mall.main,
  //     ...cart.main,
  //     ...scene.main,
  //     ...pundchoutAvoidLogin.main
  //   ]
  // },
  // 后台固定头（没有页签框架）
  // {
  //   path: '/',
  //   component: LayoutMainFixed,
  //   children: [
  //     ...help.fixed,
  //     ...processrouter.fixed
  //   ]
  // },
  // 后台详情框架（默认后台固定头，页面框架开启，则显示侧边栏）
  {
    path: '/',
    component: LayoutWrap,
    children: [
      ...fixedPage,
      ...fluidPage,
      ...mainPage
    ]
  },
  // {
  //   path: '/',
  //   component: LayoutFixedContainer,
  //   children: [
  //     ...pr.fixed,
  //     ...order.fixed,
  //     ...requisition.fixed,
  //     ...requireList.fixed,
  //     ...evaluate.fixed,
  //     ...paas.fixed

  //   ]
  // },
  // // 有侧边栏·商城后台页面
  // {
  //   path: '/',
  //   component: layoutFluidContainer,
  //   children: [
  //     ...setting.fluid,
  //     ...order.fluid,
  //     ...favorite.fluid,
  //     ...pundchoutAvoidLogin.fluid,
  //     ...evaluate.fluid,
  //     ...requisition.fluid,
  //     ...frequent.fluid,
  //     ...requireList.fluid,
  //     ...mall.field,
  //     ...pr.field,
  //     ...portal.field,
  //     ...paas.fluid
  //   ]
  // },
  // 没有匹配到任何路由的错误处理，必须放到最后面
  {
    path: '/',
    component: LayoutWrap,
    children: [
      ...error.main
    ]
  }
]

if (process.env.NODE_ENV === 'development') {
  routes[0].children.push(...member.main)
}

/* eslint-disable */
const router = new VueRouter({
  routes
})

router.afterEach((to, from) => {
  if (to.meta.title) {
    if (to.meta.title instanceof Object) {
      const title = window.fe.getPageText(to.meta.title)
      document.title = title
    } else {
      document.title = to.meta.title
    }
  }
})
router.beforeEach((to, from, next) => {
  // const fe = window.fe || {}
  // fe.pageTime = new Date().getTime() + '' + parseInt(Math.random()*1e4)
  // next()
  window.fe && window.fe.spm && window.fe.spm(to, from)
  // next()
  if (process.env.NODE_ENV === 'development') {
    if (!to.meta.isLocolLogin && !window.localStorage.getItem('loginvalue')) {
      if (to.path === '/member/login') {
        next()
      } else {
        next({ path: '/member/login' })
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
